import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { useState } from "react";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";
import { toLocaleDate } from "~/lib/localize.js";
import { LastFlightsTable } from "./LastFlightsTable.jsx";
import "./overviewFlights.css";
import { useEffect } from "react/cjs/react.production.min.js";

export const LastFlights = ({ pilot, addFlightToProfile }) => {
  const [loading, setLoading] = useState(false);
  const [flights, setFlightsData] = useState([]);
  const [count, setCount] = useState(0);
  const [currentPage, setPage] = useState(1);

  const getFlights = async (newPage) => {
    setLoading(true);
    const page = newPage || currentPage;
    const data = await api.get(
      `gegevens/${pilot.id}/flight_list.json?page=${page}`
    );
    if (data) {
      setFlightsData(data.flights);
      setCount(data.count);
    }
    setLoading(false);
  };

  const changePage = (page) => {
    setPage(page);
    getFlights(page);
  };

  const [fileLoading, setFileLoading] = useState(false);
  const downloadFile = async () => {
    setFileLoading(true);
    await api.open_file(
      "flights/export_history.json?format=xlsx&user_id=" + pilot.id,
      `${$t("vluchten")} ${pilot.name} - ${toLocaleDate(new Date())}.xlsx`
    );
    setFileLoading(false);
  };

  return (
    <div className="overviewFlightTab">
      {flights.length > 0 && !pilot.home_club && (
        <Button
          icon={<FileExcelOutlined />}
          size="small"
          loading={fileLoading}
          onClick={downloadFile}
        >
          {$t("Download")}
        </Button>
      )}

      {flights.length === 0 && <Button onClick={() => getFlights(currentPage)} loading={loading}>{$t("Haal vluchten op")}</Button>}

      {flights.length > 0 && <LastFlightsTable
        flights={flights}
        updateFlight={addFlightToProfile}
        pilot={pilot}
        loading={loading}
        totalCount={count}
        currentPage={currentPage}
        setPage={changePage}
      />}
    </div>
  );
};
